import { Controller } from '@hotwired/stimulus';

// Hover/focus tooltip for the /benchmark charts. Each mark carries
// data-benchmark-chart-tip-param = { name, value, lines: [[label, value]], footer }.
export default class extends Controller {
  static targets = ['tip'];

  show(event) {
    const data = event.params.tip;
    const lines = (data.lines || [])
      .map(([label, value]) => `<div class="flex justify-between gap-4"><span class="text-stone-600">${label}</span><span class="tabular-nums font-medium text-stone-900">${value ?? '–'}</span></div>`)
      .join('');
    this.tipTarget.innerHTML = `
      <div class="mb-2 flex justify-between font-semibold text-stone-950"><span>${data.name}</span><span class="tabular-nums">${data.value ?? ''}</span></div>
      <div class="space-y-1">${lines}</div>
      ${data.footer ? `<div class="mt-2 border-t border-stone-100 pt-2 text-xs text-stone-500">${data.footer}</div>` : ''}`;
    const box = this.tipTarget.parentElement.getBoundingClientRect(); // offsetParent is null while hidden
    const mark = event.currentTarget.getBoundingClientRect();
    const tipWidth = 240;
    const left = mark.left - box.left + (mark.width > 100 ? mark.width * 0.35 : mark.width / 2 - tipWidth / 2);
    this.tipTarget.style.top = `${mark.bottom - box.top + 6}px`;
    this.tipTarget.style.left = `${Math.min(Math.max(left, 0), box.width - tipWidth)}px`;
    this.tipTarget.classList.remove('hidden');
  }

  hide() {
    this.tipTarget.classList.add('hidden');
  }
}
